import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingScreen } from '@/components/common/LoadingScreen';
import type { Rol } from '@/types/domain';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Si se define, solo estos roles acceden; los demás ven "forbidden". */
  allowRoles?: Rol[];
}

export function ProtectedRoute({ children, allowRoles }: ProtectedRouteProps) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen message="Verificando sesión…" />;

  if (!session) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // Profile aún no cargó (pero hay session) → loading breve
  if (!profile) return <LoadingScreen message="Preparando tu panel…" />;

  if (!profile.activo) {
    return <ForbiddenScreen reason="Tu cuenta está desactivada." />;
  }

  if (allowRoles && !allowRoles.includes(profile.role)) {
    return <ForbiddenScreen reason="No tenés permisos para ver esta sección." />;
  }

  return <>{children}</>;
}

function ForbiddenScreen({ reason }: { reason: string }) {
  return (
    <div className="grid min-h-screen place-items-center px-6">
      <div className="card-premium max-w-md p-8 text-center">
        <p className="kicker mb-2">Acceso restringido</p>
        <h2 className="mb-2 text-xl font-extrabold tracking-tight">Ups.</h2>
        <p className="text-sm text-neutral-muted">{reason}</p>
      </div>
    </div>
  );
}
